import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import TextField from "../../../bootstrap/TextField/index.jsx";
import {
  ContactInputWrapper,
  ContactText,
  ContactWrapper,
  LoginText,
  LoginWrapper,
  Select,
  UserContactWrapper,
} from "./Contact.styles.js";

const Contact = ({
  setPassengerInformation,
  passengerInformation,
  values,
  setValues,
  handleChange,
  setRegesteredUser,
  token,
  paymentStutas,
  setPaymentStutas,
}) => {
  const { webSettingData, languageData } = useSelector((state) => state.busLists);
  const [isDisabled, setIsDisabled] = useState(false);
  const [userProfileInfo, setUserProfileInfo] = useState({});
  const [countryName, setCountryName] = useState([]);
  const [mobileError, setMobileError] = useState('');
  const exceptThisSymbols = ["e", "E", "+", "-", "."];
  // const [languageData, setLanguageData] = useState();

  const history = useHistory();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_MODULE_DOMAIN}/countries`)
      .then((res) => res.json())
      .then((data) => setCountryName(data.data));
  }, []);

  useEffect(() => {
    setIsDisabled((prevState) => !prevState);
  }, [userProfileInfo]);

  useEffect(() => {
    setUserProfileInfo(JSON.parse(localStorage.getItem("userProfileInfo")));
  }, [passengerInformation, token]);

  // useEffect(() => {
  //   fetch(`${process.env.REACT_APP_API_MODULE_DOMAIN}/localize/strings`)
  //     .then((res) => res.json())
  //     .then((data) => setLanguageData(data.data));
  // }, []);

  const handleLogin = async () => {
    history.push({
      pathname: "/login",
      state: {
        update: true,
      },
    });
  };

  const validateMobile = (value) => {
    // Only allow numeric values and max 10 digits
    const numericValue = value.replace(/\D/g, '');
    if (numericValue.length > 10) {
      setMobileError('Mobile number cannot exceed 10 digits');
      return false;
    } else if (numericValue.length > 0 && numericValue.length < 10) {
      setMobileError('Mobile number must be exactly 10 digits');
      return false;
    } else {
      setMobileError('');
      return true;
    }
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    // Remove any non-numeric characters and limit to 10 digits
    const numericValue = value.replace(/\D/g, '').slice(0, 10);
    validateMobile(numericValue);
    setPassengerInformation({
      ...passengerInformation,
      login_mobile: numericValue,
    });
  };

  useEffect(() => {
    // Set Kenya country code (254) as default
    setValues({ ...values, mobile_country_code: '254' });
  }, []);

  return (
    <>
      {!userProfileInfo && (
        <LoginWrapper>
          <strong>
            {languageData?.checkout_page_question[webSettingData?.language]}
          </strong>
          <LoginText
            onClick={handleLogin}
            textcolor={webSettingData?.buttoncolor}
            texthvcolor={webSettingData?.buttoncolorhover}
          >
            {
              languageData?.checkout_page_login_page_link[
              webSettingData?.language
              ]
            }
          </LoginText>
        </LoginWrapper>
      )}
      <ContactWrapper>
        <label htmlFor="email">
          Contacts
          <samp style={{ color: "red" }}>
            {" "}
            <b>*</b>
          </samp>
        </label>
        <div>
          <ContactInputWrapper>
            <TextField
              id="email"
              disabled={isDisabled}
              name="login_email"
              type="email"
              placeholder={
                languageData?.checkout_page_contact_details_input_email[
                webSettingData?.language
                ]
              }
              value={passengerInformation?.login_email}
              onChange={(e) =>
                setPassengerInformation({
                  ...passengerInformation,
                  login_email: e.target.value,
                })
              }
            />

            <UserContactWrapper>
              {/* Country code hidden - Kenya (+254) set as default */}
              <input
                type="hidden"
                name="mobile_country_code"
                value="254"
              />

              <TextField
                disabled={isDisabled}
                name="login_mobile"
                type="tel"
                maxLength="10"
                placeholder="07XXXXXXXX"
                onKeyDown={(e) =>
                  exceptThisSymbols.includes(e.key) && e.preventDefault()
                }
                value={passengerInformation?.login_mobile}
                onChange={handleMobileChange}
                style={{ border: "0px solid #eaeaea" }}
              />
            </UserContactWrapper>
          </ContactInputWrapper>
          <p id="email-error" style={{ color: "red" }}></p>
          <p id="mobile-error" style={{ color: "red" }}>{mobileError}</p>
          <ContactText>
            {languageData?.checkout_page_text[webSettingData?.language]}
          </ContactText>
        </div>
      </ContactWrapper>
    </>
  );
};

export default Contact;
